{
  "dashboard": {
    "title": "Strategic Dashboard",
    "subtitle": "Overview of your platform activity and key metrics.",
    "cards": {
      "matches": "Matches",
      "requestCount_one": "{{count}} request",
      "requestCount_other": "{{count}} requests",
      "fromMatchRequests_one": "From {{count}} match request",
      "fromMatchRequests_other": "From {{count}} match requests",
      "complianceStatus": "Compliance Status",
      "companyCompliance": "{{name}} compliance",
      "noCompanyData": "No company data",
      "marketAlerts": "Market Alerts",
      "highCount": "{{count}} High",
      "reviewUpdates": "Review updates",
      "noAlerts": "No alerts"
    },
    "alert": {
      "ariaLabel": "Latest market alert",
      "title": "Latest Market Alert"
    },
    "stats": {
      "ariaLabel": "Matchpoint Intelligence statistics",
      "yourCompanies": "Your Companies",
      "complianceScore": "Compliance Score",
      "marketUpdates": "Market Updates"
    },
    "activity": {
      "ariaLabel": "Recent activity",
      "title": "Recent Activity",
      "viewAll": "View all activity",
      "matchRequest": "Match Request",
      "untitledRequest": "Untitled request",
      "columns": {
        "type": "Activity Type",
        "request": "Request",
        "matches": "Matches"
      }
    },
    "empty": {
      "title": "No Activity Yet",
      "description": "Start your journey by creating your first match request with Matchpoint Intelligence. We'll help you find the perfect business partners.",
      "cta": "Create Match Request",
      "fastMatching": "Fast Matching",
      "verifiedPartners": "Verified Partners",
      "smartAnalytics": "Smart Analytics"
    }
  },
  "marketIntelligence": {
    "title": "Market Intelligence",
    "subtitle": "Curated updates on regulations, geopolitics, and business opportunities.",
    "exportPdf": "Export PDF Report",
    "loading": "Loading articles…",
    "errors": {
      "load": "Failed to load articles."
    },
    "impact": {
      "ariaLabel": "Economic impacts on your business",
      "title": "Economic Impacts on Your Business",
      "totalArticles": "Total Articles",
      "inYourFeed": "in your feed",
      "regulatoryChanges": "Regulatory Changes",
      "affectingYourSector": "affecting your sector",
      "businessGeopolitics": "Business & Geopolitics",
      "inTargetMarkets": "in target markets",
      "latest": "Latest: {{title}}",
      "openArticleHint": "Open the article below to read the full analysis."
    },
    "tabs": {
      "all": "All Updates",
      "regulations": "Regulations ({{count}})",
      "geopolitics": "Geopolitics ({{count}})",
      "business": "Business News ({{count}})",
      "watchlist": "Watchlist ({{count}})"
    },
    "category": {
      "regulation": "REGULATION",
      "geopolitics": "GEOPOLITICS",
      "businessNews": "BUSINESS NEWS"
    },
    "empty": {
      "watchlist": "No bookmarked articles yet. Click the bookmark icon on any article to save it here.",
      "category": "No articles in this category."
    },
    "article": {
      "source": "Source: {{source}}",
      "readFull": "Read Full Article",
      "savedToWatchlist": "Saved to Watchlist",
      "addToWatchlist": "Add to Watchlist"
    }
  },
  "notifications": {
    "title": "Notifications",
    "summary": "{{total}} total · {{unread}} unread",
    "markAllRead": "Mark all as read",
    "loading": "Loading notifications…",
    "errors": {
      "load": "Failed to load notifications."
    },
    "empty": "You have no notifications.",
    "fallbackTitle": "Notification",
    "markRead": "Mark as read",
    "read": "Read",
    "page": "Page {{page}}"
  },
  "contracts": {
    "title": "Contracts",
    "subtitle": "Manage and view all contract documents",
    "exportAllAria": "Export all contracts",
    "exportAll": "Export All Contracts",
    "searchPlaceholder": "Search contracts...",
    "searchAria": "Search contracts",
    "filters": {
      "statusAria": "Filter by status",
      "allStatuses": "All statuses",
      "typeAria": "Filter by type",
      "allTypes": "All types"
    },
    "status": {
      "draft": "Draft",
      "active": "Active",
      "accepted": "Accepted",
      "completed": "Completed",
      "cancelled": "Cancelled"
    },
    "types": {
      "partnership": "Partnership",
      "technology": "Technology",
      "supply": "Supply",
      "distribution": "Distribution",
      "jointVenture": "Joint Venture"
    },
    "loading": "Loading contracts…",
    "errors": {
      "load": "Failed to load contracts."
    },
    "empty": "No contracts yet.",
    "cardTitle": "{{type}} with {{counterpart}}",
    "contractFallback": "Contract",
    "meta": {
      "type": "Type: {{type}}",
      "value": "Value: {{value}}"
    },
    "viewDetailsAria": "View details",
    "viewDetails": "View Details",
    "downloadAria": "Download contract",
    "download": "Download"
  },
  "contractDetails": {
    "title": "{{type}} with {{counterpart}}",
    "contractFallback": "Contract",
    "closeAria": "Close modal",
    "reference": "Ref: {{ref}}",
    "fields": {
      "contractType": "CONTRACT TYPE",
      "contractValue": "CONTRACT VALUE",
      "dateSigned": "DATE SIGNED",
      "status": "STATUS",
      "startDate": "START DATE",
      "endDate": "END DATE"
    },
    "description": "Description",
    "noDescription": "No description available.",
    "terms": "Terms and Conditions",
    "noTerms": "No terms and conditions available.",
    "documents": "Documents",
    "documentFallback": "Document {{index}}",
    "parties": "Contract Parties",
    "partyA": "Party A",
    "partyAMine": "Party A (Your Company)",
    "partyB": "Party B",
    "partyBMine": "Party B (Your Company)"
  },
  "messages": {
    "title": "Messages",
    "subtitle": "Communicate with your business partners.",
    "moderatorFallback": "MatchPoint moderator",
    "timeAgo": {
      "justNow": "Just now",
      "minutes": "{{count}}m ago",
      "hours": "{{count}}h ago",
      "days": "{{count}}d ago"
    },
    "errors": {
      "upload": "Upload failed",
      "loadConversations": "Failed to load conversations."
    },
    "listAria": "Conversation list",
    "searchPlaceholder": "Search conversations...",
    "searchAria": "Search conversations",
    "empty": {
      "noMatches": "No conversations match your search.",
      "noConversations": "No conversations yet."
    },
    "noMessagesPreview": "No messages yet",
    "newConversation": "New conversation",
    "detailAria": "Conversation detail",
    "selectPrompt": "Select a conversation or start one from Match Results.",
    "loadingConversation": "Loading conversation…",
    "relatedMatch": "Related Match",
    "openMatchAria": "Open match details",
    "lastMessage": "Last message {{time}}",
    "threadEmpty": "No messages yet. Say hello!",
    "attachFile": "Attach file",
    "composerPlaceholder": "Type your message...",
    "sendAria": "Send message"
  },
  "opportunities": {
    "title": "Opportunities",
    "subtitle": "Buyers matched with your company. Accept to open a conversation with the buyer, or decline.",
    "disclosure": "Disclosure: {{text}}",
    "filterAria": "Filter opportunities",
    "loading": "Loading opportunities…",
    "errors": {
      "load": "Failed to load opportunities.",
      "accept": "Could not accept this match.",
      "decline": "Could not decline this match.",
      "openConversation": "Could not open the conversation."
    },
    "empty": {
      "all": "No buyer has been matched with your company yet. New matches appear here and in your notifications.",
      "filtered": "Nothing here for this filter."
    },
    "details": {
      "productService": "Product / service",
      "hsCode": "HS code",
      "quantity": "Quantity",
      "targetRegions": "Target regions",
      "timeline": "Timeline"
    },
    "cardAria": "Opportunity: {{title}}",
    "matchedOn": "Matched {{date}}",
    "yourMatched": {
      "product": "Your matched product",
      "service": "Your matched service",
      "item": "Your matched item"
    },
    "winWinScore": "Win-win match score",
    "decline": "Decline",
    "accept": "Accept",
    "accepting": "Accepting…",
    "reasonLabel": "Reason (optional)",
    "reasonPlaceholder": "For example: no capacity this season",
    "reasonHint": "Only the MatchPoint team sees this reason, not the buyer.",
    "declining": "Declining…",
    "declineMatch": "Decline match",
    "acceptedOn": "Accepted {{date}}",
    "openConversation": "Open conversation",
    "messageBuyer": "Message the buyer",
    "declinedOn": "You declined this match on {{date}}.",
    "declinedOnWithReason": "You declined this match on {{date}} — “{{reason}}”."
  },
  "matchResults": {
    "title": "Match Results Feed",
    "subtitle": "Browse and connect with potential business partners.",
    "disclosure": "Disclosure: {{text}}",
    "export": "Export Results",
    "loading": "Loading match results…",
    "errors": {
      "load": "Failed to load match results."
    },
    "weighting": {
      "button": "Filter by Weighting",
      "buttonActive": "Filter by Weighting · {{filter}}",
      "minScoreShort": "≥{{min}}%",
      "documentsReviewed": "Documents reviewed",
      "all": "All matches",
      "high": "Win-Win Score ≥ {{min}}%",
      "verifiedOnly": "Documents reviewed only"
    },
    "summary": {
      "totalRequests": "Total Requests",
      "totalResults": "Total Results"
    },
    "searchPlaceholder": "Search matches...",
    "searchAria": "Search matches",
    "empty": "No match results yet.",
    "cardAria": "Match result for {{name}}",
    "card": {
      "score": "WIN-WIN MATCH SCORE",
      "matchedItem": "MATCHED PRODUCT/SERVICE",
      "hsCode": "HS Code: {{code}}",
      "ahpBreakdown": "AHP CRITERIA BREAKDOWN",
      "industryMatch": "Industry Match",
      "geographicLocation": "Geographic Location",
      "viewProfile": "View Full Profile",
      "initiateContact": "Initiate Contact"
    }
  },
  "matchResultsModal": {
    "title": "Match Results",
    "details": {
      "productService": "PRODUCT/SERVICE",
      "hsCode": "HS CODE",
      "dateCreated": "DATE CREATED"
    },
    "stats": {
      "totalMatches": "TOTAL MATCHES",
      "avgScore": "AVG MATCH SCORE",
      "highConfidence": "HIGH CONFIDENCE"
    },
    "failed": "Matching couldn't run — we've been notified, try again later.",
    "empty": "No match results yet.",
    "card": {
      "score": "WIN-WIN MATCH SCORE",
      "matchedItem": "MATCHED PRODUCT/SERVICE",
      "hsCode": "HS Code: {{code}}",
      "ahpBreakdown": "AHP CRITERIA BREAKDOWN",
      "industryMatch": "Industry Match",
      "geographicLocation": "Geographic Location",
      "viewProfile": "View Full Profile",
      "initiateContact": "Initiate Contact"
    }
  },
  "hsCodeModal": {
    "title": "Add Product/Service - Select HS Code",
    "closeAria": "Close modal",
    "aiTitle": "Suggested by the HS classifier",
    "aiSubtitle": "Official HS 2022 codes for \"{{productName}}\", chosen by several sources voting. Pick the deepest code you are sure of.",
    "manualLabel": "Can't find it? Enter HS Code manually",
    "manualPlaceholder": "e.g. 8471.30",
    "manualHint": "Typing here overrides the pick above. The code is checked against the HS 2022 table.",
    "adding": "Adding...",
    "errors": {
      "selectRequired": "Please select an HS Code or enter one manually to continue."
    },
    "manualFound": "In the HS table: {{description}}",
    "manualUnknown": "This code isn't in the current HS table. You can still save it, but it will show as unverified and won't narrow matching."
  },
  "companyProfile": {
    "matchScore": "MATCH SCORE",
    "overview": "Company Overview",
    "industry": "Industry: {{industry}}",
    "location": "Location: {{location}}",
    "matchedItem": "Matched Product/Service",
    "hsCode": "HS Code: {{code}}",
    "ahpCriteria": "AHP Matching Criteria",
    "industryMatch": "Industry Match",
    "geographicLocation": "Geographic Location",
    "dealTimeline": "Deal Timeline",
    "contract": "Contract",
    "document": "Document {{index}}",
    "initiateContact": "Initiate Contact"
  },
  "requests": {
    "title": "Requests",
    "subtitle": "Describe what you're looking for and customize how potential suppliers are evaluated.",
    "tabs": {
      "new": "New Request",
      "mine": "My Requests ({{count}})"
    },
    "errors": {
      "weightTotal": "Total weight must be exactly {{required}}. Current total is {{total}}. Please adjust the criteria so they sum to {{required}}.",
      "titleRequired": "Requirement title is required.",
      "submit": "Request submission failed. Please try again.",
      "startDraft": "Failed to start match engine on draft.",
      "updateDraft": "Failed to update draft. Please try again.",
      "retry": "Retry failed. Please try again later.",
      "load": "Failed to load requests. Please try again.",
      "outOfCreditsCta": "View your plan and buy credits"
    },
    "form": {
      "title": "Requirement Submission Form",
      "requirementTitle": "Requirement Title",
      "requirementTitlePlaceholder": "e.g., Seeking Industrial Automation Suppliers",
      "lookingFor": "Looking for",
      "aProduct": "A product",
      "aService": "A service",
      "productServiceName": "Product/Service Name",
      "productServicePlaceholder": "Enter product or service",
      "hsCode": "HS Code",
      "hsCodePlaceholder": "e.g., 8537.10.00",
      "quantityVolume": "Quantity/Volume",
      "quantityPlaceholder": "e.g., 500 units",
      "budgetRange": "Budget Range",
      "budgetPlaceholder": "e.g., $50,000 - $100,000",
      "timeline": "Timeline",
      "timelinePlaceholder": "e.g., Q1 2025",
      "preferredRegions": "Preferred Regions",
      "preferredRegionsPlaceholder": "e.g., UAE, Saudi Arabia",
      "additionalRequirements": "Additional Requirements",
      "additionalRequirementsPlaceholder": "Describe any specific certifications, compliance needs, or technical specifications..."
    },
    "weighting": {
      "title": "MCDM Weighting",
      "subtitle": "Configure match criteria",
      "ahpActive": "AHP Algorithm Active",
      "ahpHint": "Pair-wise comparison calculated automatically",
      "totalWeight": "Total Weight"
    },
    "criteria": {
      "industryFit": {
        "label": "Industry Fit",
        "description": "How well the industries align"
      },
      "companySize": {
        "label": "Company Size",
        "description": "Employee count and revenue match"
      },
      "geographicProximity": {
        "label": "Geographic Proximity",
        "description": "Distance and time zone compatibility"
      },
      "complianceScore": {
        "label": "Compliance Score",
        "description": "Trust and verification level"
      },
      "productMatch": {
        "label": "Product Match",
        "description": "Product/service compatibility"
      },
      "budgetAlignment": {
        "label": "Budget Alignment",
        "description": "Financial compatibility"
      }
    },
    "actions": {
      "cancelEdit": "Cancel edit",
      "saveDraft": "Save draft",
      "saveAsDraft": "Save as Draft",
      "submitting": "Submitting...",
      "submitAndRun": "Submit & Run Match Engine",
      "starting": "Starting…",
      "startEngine": "Start match engine",
      "retrying": "Retrying…",
      "viewResults": "View Results"
    },
    "list": {
      "title": "Active Matching Queries",
      "loading": "Loading requests...",
      "columns": {
        "title": "TITLE",
        "productService": "PRODUCT/SERVICE",
        "hsCode": "HS CODE",
        "dateCreated": "DATE CREATED",
        "status": "STATUS",
        "matches": "MATCHES",
        "actions": "ACTIONS"
      },
      "empty": "No requests yet. Create one from the \"New Request\" tab.",
      "draftBadge": "draft",
      "matchingFailed": "Matching couldn't run — we've been notified, try again later.",
      "readinessRequired": "You need to pass the export-readiness check before launching a request.",
      "readinessRequiredCta": "Take the readiness check"
    }
  },
  "readiness": {
    "title": "Export Readiness Check",
    "subtitle": "Answer a short set of questions so Matchpoint Intelligence can match you with the right opportunities. Pass the check once to unlock live match requests.",
    "gateOff": "The readiness check is currently paused by moderators — you can create match requests without taking it.",
    "currentStatus": {
      "title": "Your latest result",
      "noAssessment": "You haven't taken the check yet.",
      "takenAt": "Taken {{date}}",
      "score": "Score",
      "minScore": "Pass mark {{score}}",
      "band": "Band",
      "status": "Status",
      "passed": "Passed",
      "notPassed": "Not passed yet",
      "retake": "Retake the check"
    },
    "bands": {
      "ready": "Ready",
      "developing": "Developing",
      "not_ready": "Not ready",
      "none": "Not taken"
    },
    "form": {
      "progress": "Question {{current}} of {{total}}",
      "submit": "Submit answers",
      "submitting": "Scoring your answers…",
      "needAllAnswers": "Please answer every question before submitting."
    },
    "result": {
      "title": "Your result",
      "scoreOf": "{{score}} / 100",
      "passedLead": "You passed — you can now submit live match requests.",
      "notPassedLead": "You didn't clear the pass mark yet. Review the tips below and retake the check when you're ready.",
      "improvementTips": "Where to improve",
      "goToRequests": "Create a match request",
      "retake": "Retake the check"
    },
    "errors": {
      "loadQuestions": "Couldn't load the readiness questions.",
      "submit": "Couldn't submit your answers. Please try again."
    }
  },
  "planUsage": {
    "title": "Plan & usage",
    "subtitle": "Your plan, credits and what you've used this month.",
    "loading": "Loading your plan...",
    "loadError": "Failed to load your plan and usage.",
    "buyTitle": "Buy credits",
    "buyHint": "Credits are added to your balance as soon as the payment is confirmed. Failed matching runs are refunded.",
    "checkoutError": "Couldn't start the checkout. Please try again.",
    "noPacks": "No credit packs are on sale right now.",
    "packCredits": "{{credits}} credits",
    "buy": "Buy",
    "buyIn": "Buy in {{currency}}",
    "redirecting": "Redirecting..."
  }
}
